'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import {
  tripleWhaleProduct,
  type TripleWhaleProductIdentity,
  type TripleWhaleProductKey,
} from 'content/analytics/tripleWhaleProducts';
import { trackTripleWhaleProductView } from 'lib/analytics/tripleWhale';
import type { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import type { Currency } from 'utils/Currency';

function useTrackTripleWhaleProduct(product: TripleWhaleProductIdentity): void {
  const pathname = usePathname() ?? '';
  const id = product.id ?? '';
  const variant = product.variant ?? '';
  const price = product.price == null ? '' : String(product.price);

  useEffect(() => {
    trackTripleWhaleProductView({
      pathname,
      name: product.name,
      id,
      variant,
      price,
    });
  }, [pathname, product.name, id, variant, price]);
}

/** One product view for a catalogued buy page. */
export function useTripleWhaleProductView(
  key: TripleWhaleProductKey,
  store: ShopifyStore,
  currency?: Currency,
): void {
  useTrackTripleWhaleProduct(tripleWhaleProduct(key, store, currency));
}

/** One product view when the id comes from runtime data, such as a plan. */
export function useTripleWhaleProductDetails(
  product: TripleWhaleProductIdentity,
): void {
  useTrackTripleWhaleProduct(product);
}
